import { api } from './api';

// ── Purchase Requests ─────────────────────────────────────

export const prApi = {
  list: (params = {}) => {
    const qs = new URLSearchParams();
    if (params.status)   qs.set('status',   params.status);
    if (params.entityId) qs.set('entityId', params.entityId);
    if (params.search)   qs.set('search',   params.search);
    if (params.page)     qs.set('page',     String(params.page));
    if (params.limit)    qs.set('limit',    String(params.limit));
    const q = qs.toString();
    return api.get(q ? `/purchase-requests?${q}` : '/purchase-requests');
  },
  getById:  (id)         => api.get(`/purchase-requests/${id}`),
  create:   (data)       => api.post('/purchase-requests', data),
  update:   (id, data)   => api.patch(`/purchase-requests/${id}`, data),
  submit:   (id)         => api.post(`/purchase-requests/${id}/submit`, {}),
  approve:  (id)         => api.post(`/purchase-requests/${id}/approve`, {}),
  reject:   (id, reason) => api.post(`/purchase-requests/${id}/reject`, { reason }),
  delete:   (id)         => api.delete(`/purchase-requests/${id}`),
};

// ── Purchase Invoices ─────────────────────────────────────

export const invoiceApi = {
  list: (params = {}) => {
    const qs = new URLSearchParams();
    if (params.status)   qs.set('status',   params.status);
    if (params.vendorId) qs.set('vendorId', params.vendorId);
    if (params.poId)     qs.set('poId',     params.poId);
    if (params.entityId) qs.set('entityId', params.entityId);
    if (params.search)   qs.set('search',   params.search);
    if (params.page)     qs.set('page',     String(params.page));
    if (params.limit)    qs.set('limit',    String(params.limit));
    const q = qs.toString();
    return api.get(q ? `/purchase-invoices?${q}` : '/purchase-invoices');
  },
  getById:    (id)         => api.get(`/purchase-invoices/${id}`),
  create:     (data)       => api.post('/purchase-invoices', data),
  update:     (id, data)   => api.patch(`/purchase-invoices/${id}`, data),
  delete:     (id)         => api.delete(`/purchase-invoices/${id}`),
  submit:     (id)         => api.post(`/purchase-invoices/${id}/submit`, {}),
  approve:    (id)         => api.post(`/purchase-invoices/${id}/approve`, {}),
  reject:     (id, reason) => api.post(`/purchase-invoices/${id}/reject`, { reason }),
  post:       (id)         => api.post(`/purchase-invoices/${id}/post`, {}),
  cancel:     (id, reason) => api.post(`/purchase-invoices/${id}/cancel`, { reason }),
  uploadAttachment: (id, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post(`/purchase-invoices/${id}/attachment`, fd); // api client handles FormData
  },
};

// ── Purchase Orders ───────────────────────────────────────

export const poApi = {
  list: (params = {}) => {
    const qs = new URLSearchParams();
    if (params.status)   qs.set('status',   params.status);
    if (params.vendorId) qs.set('vendorId', params.vendorId);
    if (params.entityId) qs.set('entityId', params.entityId);
    if (params.search)   qs.set('search',   params.search);
    if (params.page)     qs.set('page',     String(params.page));
    if (params.limit)    qs.set('limit',    String(params.limit));
    const q = qs.toString();
    return api.get(q ? `/purchase-orders?${q}` : '/purchase-orders');
  },
  getById:        (id)         => api.get(`/purchase-orders/${id}`),
  create:         (data)       => api.post('/purchase-orders', data),
  update:         (id, data)   => api.patch(`/purchase-orders/${id}`, data),
  submit:         (id)         => api.post(`/purchase-orders/${id}/submit`, {}),
  approveManager: (id)         => api.post(`/purchase-orders/${id}/approve-manager`, {}),
  approveCeo:     (id)         => api.post(`/purchase-orders/${id}/approve-ceo`, {}),
  receive:        (id)         => api.post(`/purchase-orders/${id}/receive`, {}),
  cancel:         (id, reason) => api.post(`/purchase-orders/${id}/cancel`, { reason }),
};
